import { createContext, type ReactElement, type ReactNode, useContext } from 'react';

import type { TelegramPort } from './telegram-port';

const TelegramContext = createContext<TelegramPort | null>(null);

/** Makes a {@link TelegramPort} available to every screen. */
export function TelegramProvider({
  port,
  children,
}: {
  port: TelegramPort;
  children: ReactNode;
}): ReactElement {
  return <TelegramContext value={port}>{children}</TelegramContext>;
}

/**
 * The Telegram port of the running app.
 *
 * @throws {Error} when used outside `<TelegramProvider>`: a wiring bug, not a runtime case.
 */
export function useTelegram(): TelegramPort {
  const port = useContext(TelegramContext);
  if (port === null) throw new Error('useTelegram must be used inside <TelegramProvider>');
  return port;
}
